import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { Check, Target } from 'lucide-react';
export function Resultados() {
  const results = ['Entender Seller Central desde cero', 'Publicar productos correctamente en Amazon', 'Aprender FBA y FBM paso a paso', 'Encontrar productos rentables', 'Crear campañas dentro de Amazon', 'Construir un negocio online real desde casa'];
  return <section className="bg-brand-green py-20 md:py-28 px-5 sm:px-6 relative overflow-hidden" data-id="element-705">
      {/* Decorative background */}
      <div className="absolute inset-0 overflow-hidden opacity-15 pointer-events-none" data-id="element-706">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-brand-gold rounded-full blur-3xl" data-id="element-707"></div>
      </div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-708">
        <FadeIn data-id="element-709">
          <div className="text-center mb-12 md:mb-16 max-w-3xl mx-auto" data-id="element-710">
            <div className="inline-flex items-center gap-2 bg-brand-gold/15 border border-brand-gold/40 rounded-full px-5 py-2 mb-6" data-id="element-711">
              <Target className="w-4 h-4 text-brand-gold" data-id="element-712" />
              <span className="text-xs font-bold tracking-widest text-brand-gold uppercase" data-id="element-713">
                Resultados reales
              </span>
            </div>
            <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-[1.15] tracking-tight" data-id="element-714">
              Lo que podrás hacer después de aprender este sistema
            </h2>
          </div>
        </FadeIn>

        {/* Results grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5" data-id="element-715">
          {results.map((result, index) => <FadeIn key={index} delay={0.05 * (index % 6)} data-id="element-716">
              <div className="flex items-center gap-4 bg-white/5 hover:bg-white/10 border border-white/10 hover:border-brand-gold/30 rounded-2xl px-5 py-5 md:px-6 md:py-6 transition-all duration-300" data-id="element-717">
                <div className="w-10 h-10 rounded-xl bg-brand-gold/15 border border-brand-gold/30 flex items-center justify-center flex-shrink-0" data-id="element-718">
                  <Check className="w-5 h-5 text-brand-gold" strokeWidth={3} data-id="element-719" />
                </div>
                <span className="text-base md:text-lg text-white font-medium leading-snug" data-id="element-720">
                  {result}
                </span>
              </div>
            </FadeIn>)}
        </div>

        {/* CTA */}
        <FadeIn delay={0.2} data-id="element-721">
          <div className="flex justify-center mt-10 md:mt-12" data-id="element-722">
            <Button onClick={() => window.open('https://43skvt-1y.myshopify.com/products/amazon-master-system%E2%84%A2-2026-fba-fbm-wholesale-bonos-premium', '_blank', 'noopener,noreferrer')} className="w-full sm:w-auto bg-brand-gold hover:bg-brand-gold/90 text-brand-green text-base md:text-lg font-bold px-10 py-5 shadow-lg shadow-brand-gold/30" data-id="element-723">
              🚀 AMAZON MASTER SYSTEM™ 2026
            </Button>
          </div>
        </FadeIn>
      </div>
    </section>;
}